/** Where customers write for help. Defined once; every "contact support" link uses it. */
export const SUPPORT_EMAIL = "support@cortexgrip.com";
